import {type ShallowRef} from 'vue';
import {useState} from '#imports';
import type {TrendsChartTooltipState, ScatterPoint} from '../../types/TrendsChart';

export function useTrendsChartTooltip(): {
    tooltipState: ShallowRef<TrendsChartTooltipState | null>;
    clearTooltip: () => void;
    commitTooltipForElement: (params: {datasetIndex: number; dataIndex: number; point: ScatterPoint; mouseEvent: MouseEvent}) => void;
} {
    const tooltipState = useState<TrendsChartTooltipState | null>('trends-chart-tooltip', () => null);

    function clearTooltip() {
        tooltipState.value = null;
    }

    function commitTooltipForElement(params: {datasetIndex: number; dataIndex: number; point: ScatterPoint; mouseEvent: MouseEvent}) {
        const anchors = _tooltipAnchorsFromMouseEvent(params.mouseEvent);
        if (!anchors) {
            tooltipState.value = null;
            return;
        }

        const current = tooltipState.value;
        if (current && current.datasetIndex === params.datasetIndex && current.dataIndex === params.dataIndex) {
            return;
        }

        tooltipState.value = {
            datasetIndex: params.datasetIndex,
            dataIndex: params.dataIndex,
            point: params.point,
            pointPosition: anchors.pointPosition,
            tooltipPosition: anchors.tooltipPosition,
        };
    }

    function _tooltipAnchorsFromMouseEvent(mouseEvent: MouseEvent): {
        pointPosition: {x: number; y: number};
        tooltipPosition: {isRight: boolean; isBottom: boolean};
    } | null {
        if (!mouseEvent.clientX || !mouseEvent.clientY) {
            return null;
        }
        const pointPosition = {x: Math.round(mouseEvent.clientX), y: Math.round(mouseEvent.clientY)};
        const tooltipPosition = {
            isRight: pointPosition.x > window.innerWidth / 2,
            isBottom: pointPosition.y > window.innerHeight / 2,
        };
        return {pointPosition, tooltipPosition};
    }

    return {
        clearTooltip,
        commitTooltipForElement,
        tooltipState,
    };
}
